import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';

import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';

import Logo from './Logo';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    item: {
      // 上下左右に中央寄せ
      display: 'flex', // 並列レイアウト法を flexにする → 子の margin: 'auto', padding: 0 に初期化される
      alignItems: 'center', // 縦方向に中央寄せ
      justifyContent: 'center', // 横方向に中央寄せ
    },

    logo: {
      margin: '96px',
    },

    item_text: {
      textAlign: 'center',
    },
  })
);

function Footer() {
  const classes = useStyles();

  return (
    <Paper
      style={{ position: 'static', bottom: 0, left: 0, right: 0 }}
      elevation={2}
    >
      <Grid container>
        <Grid item xs={12} className={classes.item}>
          <div className={classes.logo}>
            <Logo />
          </div>
        </Grid>
        <Grid
          item
          xs={12}
          style={{
            paddingBottom: '11px',
          }}
        >
          <Typography variant="body2" className={classes.item_text}>
            Copyright ©︎ SHIINE-Sangyou, Inc.
          </Typography>
        </Grid>
      </Grid>
    </Paper>
  );
}

export default Footer;
